import { QUESTION_CONTROL_TYPE } from '@nocode/types/questionnaire.type';

export const getFormControlType = (activeChildComponent: string) => {
  const validFormControls = Object.values(QUESTION_CONTROL_TYPE) as string[];
  if (activeChildComponent === 'datePicker') {
    return QUESTION_CONTROL_TYPE.DATE;
  }

  if (activeChildComponent === 'radioButton') {
    return QUESTION_CONTROL_TYPE.RADIO;
  }

  if (
    activeChildComponent &&
    validFormControls.includes(activeChildComponent)
  ) {
    return activeChildComponent;
  }
};
